<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card class="py-5">
        <div slot="no-body" class="full-page-bg-color pb-10">
          <div class="vx-row no-gutter">
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Verify your account</h4>
                  <p class="text-justify">Please set your password</p>
                </div>
                <vs-input
                  id="password"
                  ref="password"
                  v-validate="'required|min:8'"
                  type="password"
                  name="Password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('Password') }}</span>
                  <vs-input
                    v-validate="'required|confirmed:password|min:8'"
                    type="password"
                    name="password_confirmation"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Confirm password"
                    v-model="confirm_password"
                    data-vv-as="password"
                    class="w-full pt-3" />
                    <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
                  <vs-button type="filled" @click="confirmVerify" :disabled="!validateForm" class="mt-5 w-full">Save</vs-button>
              </div>
            </div>
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/verify.svg" alt="register" height="300" class="mx-auto">
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
    import axios from '@/axios'
    export default {
        name: "ConfirmVerify",
        data(){
          return{
            password: '',
            confirm_password: ''
          }
        },
        methods:{
          async confirmVerify(){
            try{
              this.$vs.loading()
              await axios.post('/account/verify/',{ password:this.password,code:this.$route.query.code })
              this.$router.push('/login',()=>{})
              this.$ntSet()
            }catch (error){
              this.$ntSetError('warning',error.data.message)
              throw error
            }finally {
              this.$vs.loading.close()
            }
          },
          focusField() {
            document.getElementById('password').focus()
          }
        },
        computed:{
          validateForm () {
            return !this.errors.any() && this.confirm_password !== '' && this.password !== ''
          }
        },
        mounted() {
          this.focusField()
        }
    }
</script>

<style scoped>

</style>
